import { mapState, mapGetters, mapActions } from 'vuex'

export const memberListComputed = {
  ...mapState('memberList', {
    loading: (state) => state.loading,
  }),
  ...mapGetters('memberList', ['getMemberList']),
}

export const memberListMethods = mapActions('memberList', [
  'fetchingMemberList',
  'resetMemberList',
  'deleteMemberById',
  'exportMemberCsv',
])
